import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { cpfCnpj, onlyNumbers } from 'utils/format'
import { Form as FormComponent } from 'components/Form'
import {
  TitleForm,
  InputForm,
} from 'components/Form/components'
import { ApiErrors } from 'ui-components/ApiErrors'

export default function Form(props) {
  const {
    customer,
    onCancel,
    onSave,
    saving,
    responseError,
  } = props

  const [attributes, setAttributes] = useState({})

  useEffect(() => {
    setAttributes({ ...customer.attributes })
  }, [customer])

  const updateAttr = (name, value) => {
    setAttributes({
      ...attributes,
      [name]: value,
    })
  }

  const handleSave = () => {
    onSave(attributes)
  }

  const handleChange = (evt) => {
    const { value, name } = evt.target
    updateAttr(name, value)
  }

  const handleChangeDoc = (evt) => {
    const { value, name } = evt.target
    const doc = onlyNumbers(value)
    updateAttr(name, doc)
  }

  return (
    <FormComponent
      onCancel={onCancel}
      onSave={handleSave}
      saving={saving}
    >
      <TitleForm>Cliente</TitleForm>

      <ApiErrors responseError={responseError} />

      <InputForm
        fullWidth
        label="Nome"
        type="text"
        name="name"
        value={attributes.name}
        onChange={handleChange}
      />
      <InputForm
        fullWidth
        label="E-mail"
        type="text"
        name="email"
        value={attributes.email}
        onChange={handleChange}
      />
      <InputForm
        fullWidth
        label="CPF/CNPJ"
        type="text"
        name="document1"
        value={cpfCnpj(attributes.document1)}
        onChange={handleChangeDoc}
      />
      <InputForm
        fullWidth
        label="Data de nascimento"
        type="date"
        name="birthdate"
        value={attributes.birthdate}
        onChange={handleChange}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </FormComponent>
  )
}

Form.propTypes = {
  customer: PropTypes.objectOf(PropTypes.any),
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool,
  responseError: PropTypes.objectOf(PropTypes.any),
}

Form.defaultProps = {
  customer: { attributes: {} },
  saving: false,
  responseError: {},
}
